import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendances/_layout/overview/')({
  component: () => null
});